import { LanguageCategory_Language } from '__generated__/protobuf/journey/data/categories/language_category';

import { fetchTraitByAnonymousId } from 'components/api';
import { Locale, LOCALES } from 'components/helpers/types';

export async function determinePreferredLocale({
  localeFromCookie,
  anonId,
}: {
  localeFromCookie?: string;
  anonId?: string;
}): Promise<Locale | null> {
  if (localeFromCookie === LOCALES.SPANISH || localeFromCookie === LOCALES.ENGLISH) {
    return localeFromCookie as Locale;
  }

  const result = await fetchTraitByAnonymousId('language_preference', anonId);
  const traitValue =
    result?.data?.insightV2?.getTraitForIdentifier?.trait?.value?.kind?.stringValue;

  if (traitValue === LanguageCategory_Language.SPANISH) return LOCALES.SPANISH;
  if (traitValue === LanguageCategory_Language.ENGLISH) return LOCALES.ENGLISH;

  return null;
}
